import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tabs from "@mui/material/Tabs";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState } from "react";

// Transition animation
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const KategoriChecklistQCDialog = ({
  dataQC,
  openQC,
  handleCloseQC,
  onSelect,
}) => {
  const [selectedTab, setSelectedTab] = useState("Kategori Checklist ");
  const [selectedTabComponent, setSelectedComponent] = useState("");

  const colors = ["#f8bbd0", "#b2ebf2", "#c5e1a5", "#ffe082", "#d1c4e9"];

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  if (newValue === "Kategori Checklist ") {
    setSelectedComponent(""); // Hapus tab kedua saat kembali
  }
  };

  const handleSelectChecklist = (ChecklistQC) => {
    setSelectedComponent(ChecklistQC.name);
    setSelectedTab(ChecklistQC.name);
  };

  const handleSelectComponent = (component) => {
    onSelect?.(component); // Kirim ke parent
  };

  return (
    <Dialog
      fullScreen
      open={openQC}
      onClose={handleCloseQC}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseQC}
            aria-label="close"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1, textAlign: "center" }} variant="h6">
            Checklist QC
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2, bgcolor: "#f5f5f5", height: "100vh", boxSizing: "border-box" }}>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={selectedTab}
          onChange={handleChangeTab}
          sx={{ mb: 2, bgcolor: "#ffffff", borderRadius: 2 }}
        >
          <Tab label="Kategori Checklist " value="Kategori Checklist " />
          {selectedTabComponent && (
            <Tab label={selectedTabComponent} value={selectedTabComponent} />
          )}
        </Tabs>

        <Box sx={{ overflowY: "auto", height: "calc(100vh - 160px)" }}>
          {selectedTab === "Kategori Checklist " ? (
            <List>
              {dataQC.map((ChecklistQC, index) => (
                <ListItem
                  key={index}
                  onClick={() => handleSelectChecklist(ChecklistQC)}
                  sx={{
                    bgcolor: "#fff",
                    borderRadius: 2,
                    mb: 1,
                    boxShadow: 1,
                    cursor: "pointer",
                    px: 2,
                    py: 1.5,
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        color="text.primary"
                      >
                        {ChecklistQC.name}
                      </Typography>
                    }
                  />
                  <IconButton edge="end">
                    <ArrowForwardIosIcon fontSize="small" />
                  </IconButton>
                </ListItem>
              ))}
            </List>
          ) : (
            <List>
            {dataQC
              .find((item) => item.name === selectedTabComponent)
              ?.components.map((component, index) => (
                <ListItem
                  key={index}
                  onClick={() => handleSelectComponent(component)}
                  sx={{
                    bgcolor: "#fff",
                    borderRadius: 2,
                    mb: 1,
                    boxShadow: 1,
                    cursor: "pointer",
                    px: 2,
                    py: 1.5,
                  }}
                >
                    <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                backgroundColor: colors[index % colors.length],
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mr: 2,
              }}
            >
                {/* Inisial nama (huruf pertama) */}
              <Typography variant="subtitle2" fontWeight="bold">
              {(component.charAt(0) + component.charAt(component.length - 1)).toUpperCase()}
              </Typography>
            </Box>
                  <ListItemText
                    primary={
                      <Typography variant="body2" color="text.primary">
                        {component}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
          </List>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default KategoriChecklistQCDialog;
